import { useCallback, useEffect, useState } from "react";

import { Icon } from "semantic-ui-react";

import type { OpenAPI } from "simplydo/interfaces";

import api from "api";
import { useAppSelector } from "store";

import RowComponent from "components/lib/RowComponent";

const HomePages = () => {
  const [pinnedPages, setPinnedPages] = useState<
    OpenAPI.Schemas["CustomPage"][]
  >([]);
  const user = useAppSelector((state) => state.user);
  const orgId = user.ownerOrganisation?._id;

  const getPinnedPages = useCallback(() => {
    api.pages.getPinned(
      "organisation",
      orgId,
      ({ pages: newPages }) => {
        setPinnedPages(newPages);
      },
      () => {},
    );
  }, [orgId]);

  useEffect(() => {
    getPinnedPages();
  }, [getPinnedPages]);

  if (!pinnedPages.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>Pages</RowComponent.Title>
      </RowComponent.Fill>
      {pinnedPages.map((page) => (
        <RowComponent.Cell
          key={page._id}
          as="a"
          target="_blank"
          rel="noreferrer"
          href={page.link}
        >
          <Icon name="linkify" size="large" />
          <RowComponent.Title>{page.title}</RowComponent.Title>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
};

export default HomePages;
